import React, { useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import Checkmark from '~/icons/checkmark.svg';
import { useFrame } from '~/shared/utils';
import { useRouter } from 'next/router';
import Flex from '~/shared/components/Flex';

export const useSuccessInfo = () => {
    const router = useRouter();
    const { data: frame } = useFrame();
    const toastId = useRef<number | string>();

    const handleOnClick = () => {
        if (toastId.current) {
            toast.dismiss(toastId.current);
        }
        router.push(frame?.settings?.pageReferences?.basketPage?.url ?? '');
    };

    return useCallback((message) => {
        toastId.current = toast.success(
            <Flex justifyContent="center">
                <Checkmark />
                <span>{message}</span>
            </Flex>,
            {
                theme: 'dark',
                autoClose: 2500,
                closeOnClick: false,
                containerId: 'toastmaincontainer',
                onClick: handleOnClick,
            },
        );
    }, []);
};
